import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VDialog,
    { attrs: { value: _vm.showDialog, width: "400", persistent: "" } },
    [
      _c(
        VCard,
        [
          _c(
            VCardTitle,
            [
              _vm.type === "success"
                ? _c(VIcon, { attrs: { color: "success", left: "" } }, [
                    _vm._v("fas fa-check"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "info"
                ? _c(VIcon, { attrs: { color: "info", left: "" } }, [
                    _vm._v("fas fa-info-circle"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "error"
                ? _c(VIcon, { attrs: { color: "error", left: "" } }, [
                    _vm._v("fas fa-times-circle"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "warning"
                ? _c(VIcon, { attrs: { color: "warning", left: "" } }, [
                    _vm._v("fas fa-exclamation-triangle"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("I18nLabel", { attrs: { label: _vm.title } }),
            ],
            1,
          ),
          _vm._v(" "),
          _c(
            VCardText,
            [
              _vm.errors.length
                ? [
                    _c(
                      "ul",
                      _vm._l(_vm.errors, function (error) {
                        return _c("li", [
                          _c(
                            "strong",
                            [
                              _c("I18nLabel", {
                                attrs: {
                                  label: error.objectName + "." + error.field,
                                },
                              }),
                            ],
                            1,
                          ),
                          _vm._v(
                            "\n                        " +
                              _vm._s(error.message) +
                              "\n                    ",
                          ),
                        ])
                      }),
                      0,
                    ),
                  ]
                : _c("I18nLabel", { attrs: { label: _vm.text } }),
            ],
            2,
          ),
          _vm._v(" "),
          _c(
            VCardActions,
            [
              _c(VSpacer),
              _vm._v(" "),
              _vm.confirmKey
                ? _c(
                    VBtn,
                    {
                      attrs: { text: "", color: _vm.confirmButtonColor },
                      on: { click: _vm.aConfirm },
                    },
                    [
                      _c("I18nLabel", {
                        attrs: { label: _vm.confirmButtonLabel },
                      }),
                    ],
                    1,
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.confirmKey
                ? _c(
                    VBtn,
                    { attrs: { text: "" }, on: { click: _vm.aCancel } },
                    [_c("I18nLabel", [_vm._v("defaults.cancel")])],
                    1,
                  )
                : _c(
                    VBtn,
                    { attrs: { text: "" }, on: { click: _vm.aCancel } },
                    [_c("I18nLabel", [_vm._v("defaults.close")])],
                    1,
                  ),
            ],
            1,
          ),
        ],
        1,
      ),
    ],
    1,
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }